import {
    Api,
    getGetParams,
    getPostParams,
    getPutParams,
    getDeleteParams,
} from '../../utils';
import urls from '../../config/urls';
import {
    CityPayloadType,
    BusinessPartnerPayLoadType,
    PostalCodePayloadType,
    DuplicateBPCheckPayloadType,
} from './types';

export function fetchLookUpApi() {
    return Api.fetch(urls.lookup, getGetParams());
}

export function fetchCitiesAndPostalCodesByCountryApi(countryID) {
    return Api.fetch(
        `${urls.cityAndPostalCode}/${countryID}/addressinfo`,
        getGetParams()
    );
}

export function checkDubplicateOfApi(payload: DuplicateBPCheckPayloadType) {
    return Api.fetch(`${urls.checkDuplicate}`, getPostParams(payload));
}

export function retainUpdatedBusinessParterApi(businessPartnerID: number) {
    return Api.fetch(
        `${urls.businessPartner}/${businessPartnerID}`,
        getGetParams()
    );
}

export function deleteDuplicateBPApi(businessPartnerID: number) {
    return Api.fetch(
        `${urls.checkDuplicate}/${businessPartnerID}`,
        getGetParams()
    );
}

export function createCityApi(payload: CityPayloadType) {
    return Api.fetch(urls.city, getPostParams(payload));
}

export function updateCityApi({
    cityID,
    payload,
}: {
    cityID: number;
    payload: CityPayloadType;
}) {
    return Api.fetch(`${urls.city}/${cityID}`, getPutParams(payload));
}

export function createBusinessPartnerApi(payload: BusinessPartnerPayLoadType) {
    return Api.fetch(urls.businessPartner, getPostParams(payload));
}

export function updateBusinessPartnerApi(payload: BusinessPartnerPayLoadType) {
    return Api.fetch(
        `${urls.businessPartner}/${payload.bpId}`,
        getPutParams(payload)
    );
}

export function createPostalCodeApi(payload: PostalCodePayloadType) {
    return Api.fetch(urls.postalCode, getPostParams(payload));
}

export function updatePostalCodeApi({
    postalCodeID,
    payload,
}: {
    postalCodeID: number;
    payload: PostalCodePayloadType;
}) {
    return Api.fetch(
        `${urls.postalCode}/${postalCodeID}`,
        getPutParams(payload)
    );
}

export function deleteBusinessPartnerApi(businessPartnerID: number) {
    return Api.fetch(
        `${urls.businessPartner}/${businessPartnerID}`,
        getDeleteParams()
    );
}

export function fetchBicSwiftsApi(bankCountryCode: string) {
    const url = `${urls.countryBanks}/${bankCountryCode}/bank`;
    return Api.fetch(url, getGetParams());
}
export function fetchBankBranchApi(bicSwiftCode: string) {
    const url = `${urls.bankBranch}/${bicSwiftCode}`;
    return Api.fetch(url, getGetParams());
}
